export const OrderQueueOriginType = Object.freeze({
    Order: "Order",
    OrderId: "OrderId",
    OrderIdPoison: "OrderIdPoison",
    OrderSubEgress: "OrderSubEgress",
    OrderSubEgressPoison:  "OrderSubEgressPoison",
    OrderSubIngress: "OrderSubIngress",
    OrderSubIngressPoison: "OrderSubIngressPoison",
})